import styled from "styled-components";

export const CannedResonse = styled.div`
  width: 100%;
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 20, 51, 0.24) 0px 8px 20px;
  z-index: 2;
  border-radius: 4px;
  position: relative;
  // height: 350px;
  // max-height: 60vh;
  // position: absolute;
  // top: 28%;
`;

export const TabItemsStyle = styled.div`
  display: flex;
  flex-direction: row;
  -webkit-box-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  align-items: center;
  border-bottom: 1px solid rgb(239, 242, 246);
  padding: 0px 10px;

  .tab-content {
    width: 100%;
  }

  .tabItemStyle {
    display: flex;
    align-items: flex-end;
    // height: 45px;
    width: 100%;
    // padding: 0px 10px;
    // border-bottom: 1px solid rgb(226, 232, 239);
  }

  .tabItemStyle > div {
    width: 100%;
    // height: calc(100% - 8px);
    display: flex;
    align-items: flex-start;
    position: relative;
    flex-flow: column;
    justify-content: flex-start;
    // top: 2px;
    // position: absolute;
  }

  .tabItemStyle > div > ul {
    display: flex;
    flex-direction: row;
    -webkit-box-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    align-items: center;
    flex: 1 1 0%;
    border: none;
  }

  .tabItemStyle ul > li > a {
    position: relative;
    // padding: 3px 8px 12px;
    font-size: 14px;
    cursor: pointer;
    color: rgb(100, 116, 145);
    border: none !important;
    font-weight: 600;
    background: #fff;
    // border-bottom: 3px solid #fff !important;
  }

  .tabItemStyle ul > li.active > a,
  .tabItemStyle ul > li.active > a:focus,
  .tabItemStyle ul > li.active > a:hover {
    color: rgb(8, 15, 26) !important;
    border-bottom: 3px solid rgb(5, 102, 255) !important;
    background: #fff !important;
    font-weight: 600 !important;
  }

  .tabItemStyle li > a:hover {
    background: #fff !important;
  }
  // ul > li > a:hover {
  //   color: rgb(8, 15, 26);
  //   border-bottom: 1px solid rgb(5, 102, 255);
  // }
`;

export const TabItemsStyleFooter = styled.div`
  border-top: 1px solid rgb(239, 242, 246);

  .tab-content {
    width: 100%;
  }

  .tabItemStyle {
    display: flex;
    align-items: flex-end;
    // height: 45px;
    width: 100%;
    // padding: 0px 10px;
    // border-bottom: 1px solid rgb(226, 232, 239);
  }

  .tabItemStyle > div {
    width: 100%;
    // height: calc(100% - 8px);
    display: flex;
    align-items: flex-start;
    position: relative;
    flex-flow: column;
    justify-content: flex-start;
    // top: 2px;
    // position: absolute;
  }

  .tabItemStyle > div > ul {
    display: flex;
    flex-direction: row;
    -webkit-box-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    align-items: center;
    flex: 1 1 0%;
    border: none;
    width: 100%;
    background: #F8F9FA;
    border-bottom: 1px solid #E2E8F0;
  }

  .tabItemStyle ul > li:first-child > a {
    // border-right: 1px solid #E2E8F0; /* Add right-side border */
    // border-left: none;
    // border-top: none;
    // background: #fff !important;
  }

  .tabItemStyle ul > li:last-child > a {
    // background: #fff !important;
    border: none;
    border-bottom: 1px solid #E2E8F0;
  }

  .tabItemStyle ul > li:last-child.active > a,
  .tabItemStyle ul > li:last-child.active > a:focus,
  .tabItemStyle ul > li:last-child.active > a:hover {
    background: #F8F9FA; !important;
  }

  .tabItemStyle ul > li > a {
    position: relative;
    // padding: 3px 8px 12px;
    font-size: 14px;
    cursor: pointer;
    color: rgb(100, 116, 145);
    // border: none !important;
    font-weight: 600;
    background: #fff;
    border-radius: 0px;
    border-left: none;
    border-top: none;
    border-right: 1px solid #E2E8F0;
    // border-bottom: 3px solid #fff !important;
    background: #F8F9FA;
  }

  .tabItemStyle ul > li.active > a,
  .tabItemStyle ul > li.active > a:focus,
  .tabItemStyle ul > li.active > a:hover {
    color: rgb(8, 15, 26) !important;
    border-bottom: 3px solid rgb(5, 102, 255) !important;
    background: #fff !important;
    font-weight: 600 !important;
  }

  .tabItemStyle li > a:hover {
    background: #fff !important;
  }

  .tabItemStyle .disabled {
    cursor: not-allowed;
  }
`;

export const SeachFormFooter = styled.div`
  position: relative;
  // margin: auto;
  // display: flex;
  // align-items: end;
  height: 98px;
  // box-shadow: 0px 0px 10px 0px #0000001a;
  border-radius: 6px;
  // margin-top: 15px;
  border: 1px solid #d9d9d9;

  .attach-btn {
    position: absolute;
    right: 13px;
    color: #d9d9d9;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    width: 100%;
    // justify-content: space-between;
    /* padding: 25px; */
    padding: 0px 0px 0px 20px;
  }

 /* Style for the select component wrapper */
.Select.custom-select {
  background-color: #ffffff; /* White background */
  border: 1px solid #d9d9d9; /* Light grey border */
  border-radius: 6px; /* Rounded corners */
  padding: 6px 12px; /* Padding inside the container */
  font-size: 14px; /* Font size */
  color: #333333; /* Text color */
  box-shadow: none; /* Default box shadow */
  transition: all 0.2s ease; /* Smooth transition for focus state */
}

/* Style when the dropdown is focused (onClick or focus) */
.Select.custom-select.is-focused {
  box-shadow: 0 0 0 2px #4a90e2; /* Blue box-shadow on focus */
}

/* Style for the placeholder text inside the dropdown */
.Select-placeholder {
  color: #bfbfbf; /* Grey placeholder text */
  font-size: 14px; /* Font size for placeholder */
  line-height: 30px; /* Center placeholder text vertically */
}

/* Style for multi-value container (selected tags) */
.Select .Select-multi-value-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

/* Style for selected tag background */
.Select .Select-multi-value {
  background-color: #e6f7ff; /* Light blue background for selected tags */
  border-radius: 4px; /* Rounded corners for tags */
  padding: 4px 10px; /* Padding inside tags */
  display: flex;
  align-items: center;
}

/* Style for the text inside tags */
.Select .Select-multi-value__label {
  color: #1890ff; /* Blue text for tags */
  font-size: 12px; /* Smaller font size for tag text */
}

/* Style for the remove button inside each tag */
.Select .Select-multi-value__remove {
  color: #1890ff; /* Blue color for the remove button */
  cursor: pointer;
  font-size: 14px; /* Font size for the remove button */
}

/* Hover effect for remove button */
.Select .Select-multi-value__remove:hover {
  background-color: #1890ff; /* Blue background on hover */
  color: white; /* White text on hover */
}

/* Style for the dropdown arrow (indicator) */
.Select .Select-arrow-zone .Select-arrow {
  color: #bfbfbf; /* Grey color for the dropdown arrow */
  transition: color 0.2s ease; /* Smooth transition for arrow color */
}

/* Hover effect for the dropdown arrow */
.Select .Select-arrow-zone .Select-arrow:hover {
  color: #4a90e2; /* Blue color when the arrow is hovered */
}

/* Input field styling (hidden input) */
.Select-input input {
  width: 5px; /* Minimized width for the input */
  box-sizing: content-box;
  font-size: 14px;
  font-family: Nunito, sans-serif;
}

/* Remove clear button in the input field */
.Select-input input::-ms-clear {
  display: none;
}

/* Style when the input field has a value (in case of multi-selection) */
.Select-control input:focus {
  outline: none; /* Remove default outline */
}

.bottom-div {
  padding-top: 2px;
    padding-bottom: 2px;
    padding-left: 0.625rem;
    padding-right: 0.625rem;
    background: #f2f4f7;
    border-radius: 0.375rem;
    font-size: 12px;
    font-weight: 600;
}


`;

export const TabInnerBody = styled.div`
  .tabComponent {
    display: grid;
    grid-template-columns: 232px 1fr;
    grid-template-rows: 1fr;
    gap: 0px;
    height: 100%;
    overflow: hidden;
    max-height: 650px;
    border: none;
  }

  .tabComponent .tabHeader {
    z-index: 1;
    box-shadow: none;
    background: transparent;
    border-right: 1px solid rgb(239, 242, 246);
    max-height: 300px;
    overflow-y: none;
  }

  .tabComponent .tabHeader:hover {
    overflow-y: auto;
  }

  .tabComponent .tabHeaderul {
    list-style-type: none;
    padding-left: 0px;
    padding-top: 8px;
    margin: 0px;
    // min-height: 100%;
    // height: 100%;
    display: flex;
    flex-direction: column;
    width: 225px;
    background: transparent;
  }

  .tabComponent .tabHeaderul .tabHeaderli {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;
    color: #354869;
    padding: 0px;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: -0.01em;
    font-weight: 500;
  }

  .tabComponent .tabHeaderul .tabHeaderli button {
    position: relative;
    outline: none;
    border: none;
    border-radius: 8px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    width: 100%;
    text-align: left;
    cursor: pointer;
    background-color: transparent;
    font-weight: 400;
    color: inherit;
    padding: 8px 12px;
    min-height: 36px;
  }

  .tabComponent .tabHeaderul .tabHeaderli button:hover,
  .tabComponent .tabHeaderul .tabHeaderli .active,
  .tabComponent .tabHeaderul .tabHeaderli button:active {
    background: rgba(100, 116, 145, 0.08);
    color: #001433;
  }

  .tabComponent .tabHeaderul .tabHeaderli button .tabHeaderp {
    margin-top: 0px;
    margin-bottom: 0px;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: -0.01em;
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .tabComponent .tabHeaderul .tabHeaderli button .tabHeaderp::before {
    content: "#";
    color: rgb(172, 184, 203);
    margin-right: 3px;
  }

  .tabComponent .tabHeaderul .tabHeaderli button span {
    opacity: 1;
    margin-left: auto;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.01em;
    font-weight: 500;
    transition: opacity 0.2s ease 0s;
    padding-left: 6px;
    white-space: nowrap;
  }

  .tabContent {
    // width: 96%;
    max-height: 300px;
    overflow-y: hidden;
  }

  .tabContent:hover {
    overflow-y: auto;
  }

  .tabContent .tabContentul {
    padding: 8px;
    margin-bottom: 0px;
    list-style: none;
    scrollbar-color: rgb(172, 184, 203) transparent;
    scrollbar-width: thin;
  }

  .tabContent .tabContentdiv {
    padding: 12px;
    border-radius: 4px;
    // background-color: rgba(100, 116, 145, 0.08);
    cursor: pointer;
  }

  .tabHeader .tabHeaderul .active {
    background-color: #dce9ff;
    border-radius: 8px;
  }

  .tabContent .tabContentdiv:hover {
    background-color: rgba(100, 116, 145, 0.08);
  }

  .tabContent .selected {
    background-color: rgba(100, 116, 145, 0.08) !important;
    color: #000 !important;
    box-shadow: none !important;
  }

  .tabContent .tabContentp {
    margin-top: 0px;
    margin-bottom: 0px;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: -0.01em;
    word-break: break-word;
  }

  .tabContent .highlighted {
    background-color: rgb(220, 233, 255);
    font-weight: bold;
  }

  .tabContent .tabContenthr {
    border-top: 1px dashed rgb(226, 232, 239);
    margin: 0px 4px;
  }
`;



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/MessageScreenFooter/MessageFooter.js